<template>
  <div v-on:click="closeList" class="form-group">
    <label v-if="fieldLabel" class="form-control-label" :for="id">{{
      fieldLabel
    }}</label>
    <vue-select
      :disabled="readonly"
      :multiple="multiple"
      :clearable="clearable"
      @input="onChange"
      :value="selectedVal"
      :options="options"
      :id="id"
      v-model="selectedVal"
      :class="addClass"
      :searchable="isSearchable"
      append-to-body
      :calculate-position="withPopper"
      :placeholder="placeholder"
      :defaultIndex="defaultIndex"
      :closeOnSelect="true"
      @close="closeEvent"
      class="veri-dagitim-selectbox"
      ref="vdSelect"
      v-click-outside="vcoConfig"
    >
      <template v-slot:no-options="{ search, searching }">
        <template v-if="searching">
          <em>{{ search }} için bir sonuç bulunamadı</em>
        </template>
      </template>
    </vue-select>
    <span v-if="error === true" class="select-error">{{ errorText }}</span>
  </div>
</template>

<script>
import VueSelect from "vue-select";
import { createPopper } from "@popperjs/core";
export default {
  name: "SelectInput",
  props: {
    fieldLabel: String,
    options: Array,
    id: String,
    error: Boolean,
    errorText: String,
    isSearchable: Boolean,
    selectedId: {
      type: [Number, String, Object, Array],
      required: false,
    },
    readonly: Boolean,
    multiple: Boolean,
    clearable: Boolean,
    placeholder: String,
    defaultIndex: Number,
    setSmallFontsForOptions: Boolean,
  },
  components: {
    VueSelect,
  },
  data() {
    return {
      selectedVal: null,
      selecytIsOpen: false,
      placement: "bottom",
      routeRuleName: "Checkout",
      vcoConfig: {
        handler: this.handler,
        middleware: this.middleware,
        events: ["click"],
      },
    };
  },
  mounted() {
    if (this.multiple) {
      if (this.options.length > 0 && this.selectedId !== undefined) {
        this.selectedVal = this.options.filter((x) =>
          this.selectedId.includes(x.code)
        );
      }
    } else {
      this.checkSelected();
    }
  },
  methods: {
    closeEvent() {
      this.selectIsOpen = false;
    },
    closeList() {
      this.selectIsOpen = !this.selectIsOpen;
      if (!this.selectIsOpen) {
        this.$refs.vdSelect.open = false;
      }
    },
    onChange() {
      this.selectIsOpen = false;
      if (this.multiple) {
        this.$emit("change", this.selectedVal ? this.selectedVal : []);
        const selectedItems = this.selectedVal.map((data) => {
          return data.code;
        });
        this.$emit("input", selectedItems);
      } else {
        this.$emit("change", this.selectedVal ? this.selectedVal : null);
        this.$emit("input", this.selectedVal ? this.selectedVal.code : null);
      }
      this.fakeClickForClosingDropdown();
    },
    middleware(event) {
      return event.target.className?.baseVal !== "veri-dagitim-selectbox";
    },
    handler() {
      const vdSelect = this.$refs.vdSelect;
      if (vdSelect.open) {
        this.$refs.vdSelect.$refs.dropdownMenu.remove();
        this.$refs.vdSelect.closeSearchOptions(true);
        this.$refs.vdSelect.onSearchBlur(true);
        this.fakeClickForClosingDropdown();
      }
    },
    fakeClickForClosingDropdown() {
      const clickEvent = new Event("click");
      document.dispatchEvent(clickEvent);
    },
    reset() {
      this.selectedVal = null;
    },
    changeToSpecificValue(id) {
      this.selectedVal = this.options.find((o) => o.option === id);
    },
    checkSelected() {
      if (
        typeof this.selectedId === "number" ||
        typeof this.selectedId === "string"
      ) {
        this.selectDetermineSelectedValue(this.selectedId);
      }
    },
    selectDetermineSelectedValue(status) {
      this.options.filter((option) => {
        if (option.code == status) {
          this.selectedVal = option;
        }
      });
    },
    multiSelectDetermineSelectedValue(val) {
      if (!val || !val.length) this.selectedVal = this.options[0];
      else {
        this.selectedVal = val.map((v) =>
          this.options.find((o) => o.option == v)
        );
      }
    },
    withPopper(dropdownList, component, { width }) {
      const getElemId = component.$refs.openIndicator.$parent.$el;
      dropdownList.style.width = width;
      dropdownList.setAttribute("data-id", getElemId.id);
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1],
            },
          },
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.placement === "top"
              );
            },
          },
        ],
      });
      return () => popper.destroy();
    },
  },
  computed: {
    addClass() {
      return [
        { error: this.error },
        { readonly: this.readonly },
        { smallFonts: this.setSmallFontsForOptions },
      ];
    },
  },
  watch: {
    selectedId(val) {
      if (typeof val === "number" || typeof val === "string") {
        this.selectDetermineSelectedValue(val);
      }
    },
  },
};
</script>

<style lang="scss">
.osm-vd {
  .form-group {
    .veri-dagitim-selectbox.v-select {
      &.smallFonts {
        font-size: 12px !important;
        width: 100%;
        border-radius: 3px;
        border: 1px solid var(--strokes-grayscale-gray-30, #d0d0d1);
        background: var(--colors-grayscale-white, #fff);
        .vs__selected-options {
          padding: 12px 10px;
        }
        @media (max-width: 400px) {
          width: auto;
        }
        @media (min-width: 400px) {
          .vs__actions {
            right: 60px;
          }
        }
      }
      &.error {
        border-color: red !important;
        border-radius: var(--radius-first);
        .vs__dropdown-toggle {
          svg {
            fill: var(--red);
          }
        }
      }
      &.vs--open {
        border-color: var(--green);
        .vs__selected {
          position: static;
        }
      }
      .vs {
        &__dropdown-toggle {
          padding: 0.625rem 0.25rem 0.625rem 0.6rem;
          border: 1px solid #d4d4d7;
          min-width: 200px;
          background: var(--grayscale-0);

          @media (max-width: 768px) {
            min-width: auto;
          }
          svg {
            fill: rgb(71, 71, 71);
          }
        }
        &__search,
        &__selected,
        &__dropdown-menu {
          min-width: inherit !important;
          li {
            font-size: 14px;
          }
        }
        &__dropdown-option--highlight {
          background: #000;
          color: #fff !important;
        }
      }
    }
    .vs--disabled {
      .vs__dropdown-toggle,
      .vs__search,
      .vs__clear,
      .vs__open-indicator {
        background: #e9ecef !important;
      }
    }
    .select-error {
      display: block;
      color: var(--red);
      width: 100%;
      margin-top: 0.25rem;
      font-size: 80%;
    }
    .readonly {
      .vs__actions {
        display: none;
      }
    }
    #paymentStatus {
      .vs__search {
        display: none;
      }
      .vs__selected-options {
        flex-basis: auto;
        flex-grow: 0;
      }
      .vs__actions {
        position: relative;
        right: 0px;
      }
    }
    [data-popper-placement="top"] {
      border-radius: 4px 4px 0 0;
      border-top-style: solid;
      border-bottom-style: none;
      box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
      margin-bottom: -7px !important;
    }
    .option {
      .veri-dagitim-selectbox.v-select {
        .vs__actions {
          z-index: 1 !important;
        }
      }
    }
  }
  .vs__dropdown-option {
    white-space: normal !important;
    font-size: 14px !important;
  }
  ::v-deep .vs__dropdown-menu,
  .vs__dropdown-menu {
    min-width: max-content !important;
  }
  ::v-deep .vs__dropdown-menu[data-id="applicationTypeFilter"] {
    min-width: auto !important;
  }
}
</style>
